module.exports = __webpack_public_path__ + "static/img/img_0344.e91d093.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/img_0344.jpg
// module id = nSNb
// module chunks = 0